type ManagerIncomingBannerProps = {
  count: number;
  preview: string;
  locale: "es" | "en";
  onOpen: () => void;
  onDismiss: () => void;
};

export function ManagerIncomingBanner({
  count,
  preview,
  locale,
  onOpen,
  onDismiss,
}: ManagerIncomingBannerProps) {
  if (count < 1) {
    return null;
  }
  const title =
    locale === "es"
      ? count === 1
        ? "Eloria te escribió"
        : `Eloria te escribió (${count})`
      : count === 1
        ? "Eloria messaged you"
        : `Eloria messaged you (${count})`;
  return (
    <div className="fixed inset-x-0 top-0 z-[80] px-3 pt-3">
      <div
        role="alert"
        className="mx-auto flex max-w-xl items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 shadow-lg"
      >
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-amber-950">{title}</p>
          {preview ? (
            <p className="mt-1 line-clamp-2 text-sm text-amber-900">{preview}</p>
          ) : null}
          <button
            type="button"
            onClick={onOpen}
            className="mt-2 rounded-md bg-amber-900 px-3 py-1.5 text-sm font-medium text-white"
          >
            {locale === "es" ? "Abrir el chat" : "Open chat"}
          </button>
        </div>
        <button
          type="button"
          onClick={onDismiss}
          className="text-sm text-amber-800"
          aria-label={locale === "es" ? "Cerrar aviso" : "Dismiss alert"}
        >
          ×
        </button>
      </div>
    </div>
  );
}
